// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"61febd99","133":"73df8cdc","186":"b9911c74","225":"d8d422a4","292":"08e87966","344":"a341cb30","372":"b8f2ad52","377":"71505042","443":"58175c77","738":"45b9a957","815":"dab4fc26","841":"2ce2d760","856":"b272277a"}[chunkId] + ".chunk.js";
};